export default [
  {
    label: 'Clientes',
    value: 'CLIENTES',
  },
  {
    label: 'Empréstimos',
    value: 'EMPRESTIMO',
  },
  {
    label: 'Login',
    value: 'LOGIN',
  },
  {
    label: 'Prorrogações',
    value: 'PRORROGACAO',
  },
  {
    label: 'Recompra Empréstimo',
    value: 'RECOMPRA_EMPRESTIMO',
  },
  {
    label: 'Recompra prorrogação',
    value: 'RECOMPRA_PORROGACAO',
  },
];
